<template>
    <div>

<section class="content">
<div class="container-fluid">

        <div class="row clearfix">

            <div class="bg-light-green" style="margin-top:-1% !important;">
                <!-- <br> -->
                <div class="row paddingku">
                    <div class="col-md-6 searching">
                        <span class="h_page">Tujuan</span> <br> <br>
                    </div>
                    <div class="col-md-3">

                    </div>
                    <div class="col-md-3 searching">
                        <div class="input-group">
                            <span class="input-group-btn">
                                <button @click="check_add_button()" type="button" class="btn bg-light-blue btn-sm waves-effect" title="Tambah Data" data-toggle="modal" data-target="#m_tambah_data"><i class="material-icons">add</i></button>
                            </span>
                            <input v-model="cari_value" @keyup="cari_data()" type="text" class="form-control" placeholder="Cari data" id="caridata" >
                        </div> <br>
                    </div>
                </div>
            </div>


            <div class="col-xs-12 card">
        <!-- ============================================================ MULAI ======================================================================== -->
                <br>



                <div class="row">
                    <div class="col-md-6">
                        <span class="huruf_input">Periode RPJMD</span>
                        <select  v-model="data.rpjmd_id" class="form-control">
                            <option value="" >-- Semua Periode --</option>
                            <option v-for="(data) in list_rpjmd" :key="data.rpjmd_id" :value="data.rpjmd_id">	{{data.periode}}</option>
                        </select>
                    </div>


                    <div class="col-md-6">
                        <span class="huruf_input">Pilih Misi</span>
                        <select @change="getData" v-model="data.misi_id" class="form-control" >
                            <option value="" >-- Semua Misi --</option>
                              <option v-for="(data) in list_misi" :key="data.misi_id" :value="data.misi_id">	&#91;	{{data.no_misi}}&#93;	{{data.uraian}}</option>
                        </select>
                    </div>
                </div>
                <br>
                <div class="table-responsive">
                    <table class="table table-bordered" style="width: 100%">
                        <thead>
                        <tr class="bg-success kepala_table_f text-center">
                            <th class="tabel_center text-center" style="width: 6%">No</th>
                            <th class="tabel_center text-center h_tengah" style="width: 45%">Uraian Tujuan</th>
                            <th class="tabel_center text-center h_tengah" style="width: ">Keterangan</th>
                            <th class="tabel_center text-center h_tengah" style="width: 15%">Pilihan</th>
                        </tr>
                        </thead>
                        <tbody>
                            <tr v-if="cek_load_data">
                                <td colspan="4" class="text-center">
                                    <img src="images/loading-plan.gif" width="450px">
                                </td>
                            </tr>
                            <template v-if="!cek_load_data">
                                <tr class="h_isitable" v-for="data in list_tujuan" :key="data.tujuan_id">
                                    <td class="tabel_center">{{data.kodeku}}</td>
                                    <td class="tabel_center" >{{data.uraian}}</td>
                                    <td class="tabel_center text-justify">{{data.keterangan}}</td>

                                    <td class="tabel_center text-center" >
                                        <button @click="selectData(data)" class="btn bg-light-green btn-xs waves-effect" title="Edit Data" id="edit_data" data-toggle="modal" data-target="#m_edit_data">
                                            <i class="material-icons" >create</i>
                                        </button>
                                            &nbsp;
                                        <button @click="removeData(data.tujuan_id)" class="btn bg-red btn-xs waves-effect" title="Hapus Data" id="hapus_data">
                                            <i class="material-icons" >clear</i>
                                        </button>
                                    </td>
                                </tr>
                            </template>


                        </tbody>
                    </table>
                </div>

                <hr>
                    <div class="text-center">
                        <button @click="btn_prev" type="button" class="btn btn-xs bg-blue waves-effect" id="pref">
                            <i class="material-icons">skip_previous</i>
                        </button>
                        &nbsp;
                        <span style="font-size: 85%; color: #a5a5a5">
                            <b>{{page_first}} - {{page_last}}</b>
                        </span>
                        &nbsp;
                        <button @click="btn_next" type="button" class="btn btn-xs bg-blue waves-effect" id="next">
                            <i class="material-icons">skip_next</i>
                        </button>
                    </div>
                <hr>
                <!-- ============================================================ MODAL ======================================================================== -->


                  <!-- xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx MODAL TAMBAH xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx -->
                    <div class="modal fade" id="m_tambah_data" tabindex="-1" role="dialog">
                        <div class="modal-dialog modal-lg" role="document">
                            <div class="modal-content">
                                <div class="modal-header bg-light-blue">
                                    <button @click="emptyData()" type="button" class="close" data-dismiss="modal" aria-label="Close">
                                        <span aria-hidden="true">&times;</span></button>
                                    <h4 class="modal-title" id="largeModalLabel">TAMBAH DATA</h4>
                                </div>
                            <form @submit.prevent="addData()">
                              <div class="modal-body" v-if="check_add" >
                                      <div class="alert alert-danger text-center">
                                          <strong>SILAHKAN PILIH PERIODE RPJMD DAN MISI TERLEBIH DAHULU!</strong> 
                                      </div>
                                    </div>
                                <div class="modal-body" v-if="!check_add" >

                                  
                                  <div class="row clearfix">
                                      <div class="col-md-2 form-control-label">
                                          <label for="kode">Nomor Tujuan</label>
                                      </div>
                                      <div class="col-md-10">
                                          <div class="form-group">
                                              <div class="form-line">
                                                <input type="number" class="form-control" v-model="data.no_tujuan">
                                              </div>
                                          </div>
                                      </div>
                                  </div>
                                  <div class="row clearfix">
                                      <div class="col-md-2 form-control-label">
                                          <label for="kode">Uraian Tujuan</label>
                                      </div>
                                      <div class="col-md-10">
                                          <div class="form-group">
                                              <div class="form-line">
                                                  <textarea rows="4" v-model="data.uraian" class="form-control no-resize" placeholder="Masukan Uraian..."></textarea>
                                              </div>
                                          </div>
                                      </div>
                                  </div>

                                  <div class="row clearfix">
                                      <div class="col-md-2 form-control-label">
                                          <label for="kode">Keterangan</label>
                                      </div>
                                      <div class="col-md-10">
                                          <div class="form-group">
                                              <div class="form-line">
                                                  <textarea rows="4" v-model="data.keterangan" class="form-control no-resize" placeholder="Masukan Keterangan..."></textarea>
                                              </div>
                                          </div>
                                      </div>
                                  </div>




                                </div>
                                <div class="modal-footer">
                                    <button type="submit" class="btn btn-info waves-effect">SIMPAN</button>
                                    <button type="button" class="btn btn-danger waves-effect" data-dismiss="modal">KEMBALI</button>
                                </div>
                            </form>
                            </div>
                        </div>
                    </div>
                  <!-- xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx MODAL TAMBAH xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx -->


                  <!-- xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx MODAL EDIT xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx -->
                    <div class="modal fade" id="m_edit_data" tabindex="-1" role="dialog">
                        <div class="modal-dialog modal-lg" role="document">
                            <div class="modal-content">
                                <div class="modal-header bg-light-green">
                                    <button @click="emptyData()" type="button" class="close" data-dismiss="modal" aria-label="Close">
                                        <span aria-hidden="true">&times;</span></button>
                                    <h4 class="modal-title" id="largeModalLabel">EDIT DATA</h4>
                                </div>
                                <form @submit.prevent="editData()">
                                    <div class="modal-body" >
                                        
                                        <div class="row clearfix">
                                            <div class="col-md-2 form-control-label">
                                                <label for="kode">Nomor Tujuan</label>
                                            </div>
                                            <div class="col-md-10">
                                                <div class="form-group">
                                                    <div class="form-line">
                                                      <input type="number" class="form-control" v-model="data.no_tujuan">
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="row clearfix">
                                            <div class="col-md-2 form-control-label">
                                                <label for="kode">Uraian Tujuan</label>
                                            </div>
                                            <div class="col-md-10">
                                                <div class="form-group">
                                                    <div class="form-line">
                                                        <textarea rows="4" v-model="data.uraian" class="form-control no-resize" placeholder="Masukan Uraian..."></textarea>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="row clearfix">
                                            <div class="col-md-2 form-control-label">
                                                <label for="kode">Keterangan</label>
                                            </div>
                                            <div class="col-md-10">
                                                <div class="form-group">
                                                    <div class="form-line">
                                                        <textarea rows="4" v-model="data.keterangan" class="form-control no-resize" placeholder="Masukan Keterangan..."></textarea>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="modal-footer">
                                        <button type="submit" class="btn btn-success waves-effect">RUBAH</button>
                                        <button type="button" class="btn btn-danger waves-effect" data-dismiss="modal">KEMBALI</button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>

                  <!-- xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx MODAL EDIT xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx -->

                <!-- ============================================================ MODAL ======================================================================== -->

        <!-- ============================================================ MULAI ======================================================================== -->
            </div>

        </div>

        </div>
      </section>

    </div>
</template>


<script>

    const ADD_URL_MISI = URL_APP+'api/v1/planning_misi/';
    const ADD_URL_RPJMD = URL_APP+'api/v1/planning_rpjmd/';
    const ADD_URL = URL_APP+'api/v1/planning_tujuan/';


    export default {
        name: "planning_tujuan",
        data() {
            return {
                data:{
                    tujuan_id: '',
                    misi_id: '',
                    no_tujuan: '',
                    uraian: '',
                    keterangan: '',
                    rpjmd_id: '',
                },
                
                check_add : false,
                list_tujuan: [],
                list_rpjmd: [],
                list_misi: [],
                check_data_length : false,
                page_first : 1,
                page_last : 0,
                cari_value : '',
                cek_load_data : true,
            };
        },

        mounted() {
            this.getDataRPJMD();
            localStorage.sidemenu = 'planing';
        },

        // =============================================================== METHODS =========================================================================
        methods : {

            getDataRPJMD: function(){
                fetch(ADD_URL_RPJMD+'readData', {
                    method : 'POST',
                    headers : {
                      "content-type": "application/json",
                      authorization: "kikensbatara " + localStorage.token
                    },
                    body : JSON.stringify({
                      data_ke : this.page_first,
                      cari_value : this.cari_value
                    })
                }).then((res) => res.json()).then((data_rpjmd) => {
                  this.list_rpjmd = data_rpjmd.data;
                  this.data.rpjmd_id = this.list_rpjmd[0].rpjmd_id
                  console.log( this.data.rpjmd_id);
                  this.getDataMisi(this.data.rpjmd_id);

                })
            },
            getDataMisi: function(rpjmd_id){
              
              fetch(ADD_URL_MISI+'misi_id_rpjmd', {
                  method : 'POST',
                  headers : {
                    "content-type": "application/json",
                    authorization: "kikensbatara "+localStorage.token
                  },
                  body : JSON.stringify({
                    rpjmd_id: rpjmd_id
                  })
              }).then((res) => res.json()).then((data_misi) => {
                this.list_misi = data_misi;
                this.data.misi_id = data_misi[0].misi_id
                this.getData();
              })
            },
            addData: function(){
                fetch(ADD_URL+'createData', {
                    method: 'POST',
                    headers: {
                        "content-type": "application/json",
                        authorization: "kikensbatara "+ localStorage.token
                    },
                    body: JSON.stringify(this.data)
                }).then(res => res.json()).then((data_urusan) => {
                    this.alertku('success', 'Berhasil Menambah Data!');
                    this.getData();
                });
            },
            getData: function(){
                this.cek_load_data = true;
                fetch(ADD_URL+'readData', {
                    method : 'POST',
                    headers : {
                      "content-type": "application/json",
                      authorization: "kikensbatara " + localStorage.token
                    },
                    body : JSON.stringify({
                      data_ke : this.page_first,
                      cari_value : this.cari_value,
                      rpjmd_id : this.data.rpjmd_id,
                      misi_id : this.data.misi_id,
                      cari_value : this.cari_value,
                    })
                }).then((res) => res.json()).then((data_tujuan) => {
                  this.list_tujuan = data_tujuan.data;
                  this.page_last = data_tujuan.jml_data;
                  this.cek_load_data = false;
                })
            },
            editData: function(){
                fetch(ADD_URL+'updateData', {
                    method: 'POST',
                    headers: {
                        "content-type": "application/json",
                        authorization: "kikensbatara " + localStorage.token
                    },
                    body: JSON.stringify(this.data)
                }).then((res_data) => {
                    this.alertku("success", "Berhasil Mengubah Data!");
                    this.getData();
                });
            },
            selectData : function(data){
              this.data = {
                    tujuan_id: data.tujuan_id,
                    misi_id: data.misi_id,
                    no_tujuan: data.no_tujuan,
                    uraian: data.uraian,
                    keterangan: data.keterangan,
                    rpjmd_id: data.rpjmd_id,
                };
            },
            removeData : function(id){
                this.$swal({
                  title: 'Apa Anda Ingin Menghapus Data?',
                  text: 'Data Yang Telah Dihapus Tidak Dapat Dikembalikan',
                  type: 'warning',
                  showCancelButton: true,
                  confirmButtonText: 'Ya',
                  cancelButtonText: 'Batal',
                  showCloseButton: true,
                  showLoaderOnConfirm: true
                }).then((result) => {
                  if(result.value) {
                    fetch(ADD_URL+"deleteData", {
                        method : 'POST',
                        headers : {
                          'content-type' : 'application/json',
                          authorization : "kikensbatara "+ localStorage.token,
                        },
                        body : JSON.stringify({
                          id : id
                        })
                    }).then(()=>{
                        this.alertku("success", "Sukses Menghapus Data!");
                        this.getData();
                    });
                    this.$swal('Terhapus', 'Berhasil Menghapus Data!', 'success')
                  } else {
                    this.$swal('Batal', 'Batal Menghapus Data!', 'info')
                  }
                })
            },
            emptyData : function(){

            },

            //PAGINASI
            alertku : function(type, title){
              this.$swal({
                type: type,
                title: title,
                showConfirmButton: false,
                timer: 800
              });
            },

            btn_prev : function(){
                this.cek_load_data = true;
                if(this.page_first>1){
                    this.page_first--
                }else{
                    this.page_first = 1;
                }
                this.getData();
            },

            btn_next : function(){
                this.cek_load_data = true;
                if(this.page_first >= this.page_last){
                    this.page_first == this.page_last
                }else{
                    this.page_first++;
                }
                this.getData();
            },

            cari_data : function(){
                this.cek_load_data = true;
                this.page_first = 1;
                this.getData();
            },
            check_add_button : function(){
              if (this.data.rpjmd_id == '' || this.data.misi_id == '' ) {
                this.check_add = true;
              } else {
                this.check_add = false;
              }
            }
        },
        // =============================================================== METHODS =========================================================================

    };
</script>
